/**
 * Korean mobile numbers — must mirror the backend's api/utils/identity.js.
 *
 * The courier calls this number, and it is what the referral anti-fraud checks
 * count identities with, so a landline or a typo is not acceptable.
 */

// 010 is the modern prefix; 011/016/017/018/019 are legacy carriers.
const KR_MOBILE = /^01[016789]\d{7,8}$/;

/** Digits only, with +82 folded back to a leading 0. */
export function toLocalDigits(phone) {
  if (!phone) return "";
  const compact = String(phone).replace(/[\s-]/g, "");
  let digits = compact.replace(/\D/g, "");
  if (/^\+?82/.test(compact) && digits.startsWith("82")) digits = "0" + digits.slice(2);
  if (!digits.startsWith("0") && /^1[016789]\d{7,8}$/.test(digits)) digits = "0" + digits;
  return digits;
}

export function isValidKoreanMobile(phone) {
  return KR_MOBILE.test(toLocalDigits(phone));
}

/** Live formatting as they type: 010-1234-5678 */
export function formatKoreanMobile(phone) {
  const d = toLocalDigits(phone).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  if (d.length <= 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}
